import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start at 13:11 -> 13 * 60 + 11 = 791 seconds
  const [timeLeft, setTimeLeft] = useState(791);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          return 791; // Reset to 13:11 when it reaches 0
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="font-bold font-mono tracking-wider" data-id="element-1">
      {minutes.toString().padStart(2, '0')}:
      {seconds.toString().padStart(2, '0')}
    </span>;
}